import { getNodeStatsItems } from 'common/builder/components/chart/FlowChart/nodes/shared/NodeStats/getNodeStatsItems'
import { FlowChartNodeStat } from 'common/builder/components/chart/FlowChart/types/FlowChartNodeStat'
import { FlowChartStatRow } from 'common/builder/components/chart/FlowChart/types/FlowChartStatRow'
import { INode } from 'common/builder/nodes/nodeInterfaces'

export function getContentNodeStatTable(
  entity: INode,
  {
    isRootWithJSONAds,
  }: {
    /**
     * Root node with selected JSON ads trigger
     * will have different stats
     */
    isRootWithJSONAds: boolean
  },
): FlowChartStatRow[] {
  return getNodeStatsItems(entity, {
    isRootNodeSelected: isRootWithJSONAds,
    isStatByJSONAdsTrigger: isRootWithJSONAds,
  }).map((row) => ({
    cols: row.map((statsEntry): FlowChartNodeStat | null => {
      if (!statsEntry) {
        return null
      }

      return {
        label: statsEntry.title,
        value: statsEntry.value,
        hoverValue: statsEntry.hoverValue,
        segmentId: statsEntry.segment,
      }
    }),
  }))
}
